/* eslint-disable react/require-default-props */
import React from 'react';
import {View} from 'react-native';
import {isFunction} from 'lodash';

import Avatar from '/component/base/Avatar';
import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import {DownlineProfile, ProfilePage} from '/constant/TestIDs';
import {copyToClipboard} from '/util/clipboard.util';
import {generateCallback} from '/util/component.util';
import testProperties from '/util/testing/testProperties';

import {styles} from './ProfileHeader.style';

interface ProfileHeaderProps {
  title?: React.ReactNode | (() => React.ReactNode);
  name: React.ReactNode;
  email: string;
  avatarUrl: string;
  isCoach: boolean;
  optaviaId: number | null;
}

const ProfileHeader: React.FC<ProfileHeaderProps> = ({
  title = '',
  name = '',
  email = '',
  avatarUrl = '',
  isCoach = false,
  optaviaId = 0,
}) => {
  return (
    <View style={styles.base}>
      <View style={styles.infoColumn} accessible={false}>
        {isFunction(title) ? (
          title()
        ) : (
          <Text
            variant="small"
            emphasis="low"
            allowFontScaling
            maxFontSizeMultiplier={2}
            style={styles.titleText}>
            {title}
          </Text>
        )}
        <Text
          variant="large"
          allowFontScaling
          maxFontSizeMultiplier={2}
          style={styles.nameText}
          testID={ProfilePage.profileFullName}>
          {name}
        </Text>
        <View style={styles.optaviaTextContainer}>
          <Text
            variant="heading"
            emphasis="dull"
            allowFontScaling
            maxFontSizeMultiplier={2}>
            OPTA
          </Text>
          <Text
            variant="small"
            emphasis="dull"
            allowFontScaling
            maxFontSizeMultiplier={2}>
            VIA ID
          </Text>
          <TouchableOpacity
            style={styles.idContainer}
            onPress={generateCallback({
              func: copyToClipboard,
              params: optaviaId?.toString(),
            })}
            {...testProperties(null, true)}>
            <Text
              variant="heading"
              allowFontScaling
              maxFontSizeMultiplier={2}
              style={styles.idText}
              useCompetency={true}
              {...testProperties(DownlineProfile.profileIdValue)}>
              {optaviaId}
            </Text>
            <Icon style={styles.copyIcon} name="copy" accessible={false} />
          </TouchableOpacity>
        </View>
      </View>
      <View style={styles.avatarColumn}>
        <Avatar
          size={64}
          avatarUrl={avatarUrl}
          avatarKey={email}
          isCoach={isCoach}
          optaviaId={optaviaId}
          fullName={name}
        />
      </View>
    </View>
  );
};

export default ProfileHeader;
